import React from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import Lottie from "lottie-react";

import BackButton from '../custom/BackButton';
import ActionIcon from '../custom/ActionIcon';
import success from '../../assets/lottie/success.json';
import error from '../../assets/lottie/error.json';
import { Button } from 'reactstrap';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    pass: boolean;
}

export default function ModalQuizResult ({
    modal,
    setModal,
    pass
}: Props) {

    const toggle = () => setModal(!modal);

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Quiz Result</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody className={'text-center'}>
                <Lottie 
                    animationData={pass ? success : error} 
                    loop={false} 
                />
                <h1 className={`${!pass && 'bg-warning'}`}>Quiz {pass ? 'Passed!' : 'Failed. Please re-take this quiz.'}</h1>
            </ModalBody>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;